"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _text = require("../../../styles/2_commonComponentStyles/text");

var _Checkable = require("./Checkable.styles");

var _idGenerator = _interopRequireDefault(require("../../../utils/idGenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * This is a foundational component, providing foundational 'checkable' functionality and styles.
 * It is used by both checkboxes and labeled radios, but is not exported for external use.
 * Checkable items do not support the tertiary style.
 */
// intentionally left as a functional component
var Checkable = function Checkable(_ref) {
  var checked = _ref.checked,
      checkedColorTheme = _ref.checkedColorTheme,
      checkedIconName = _ref.checkedIconName,
      children = _ref.children,
      className = _ref.className,
      colorTheme = _ref.colorTheme,
      dataTestId = _ref.dataTestId,
      id = _ref.id,
      name = _ref.name,
      onChange = _ref.onChange,
      uncheckedColorTheme = _ref.uncheckedColorTheme,
      uncheckedIconName = _ref.uncheckedIconName,
      props = _objectWithoutProperties(_ref, ["checked", "checkedColorTheme", "checkedIconName", "children", "className", "colorTheme", "dataTestId", "id", "name", "onChange", "uncheckedColorTheme", "uncheckedIconName"]);

  var formattedChildren = children;

  if (children.length === 1) {
    formattedChildren = [].concat(_toConsumableArray(children), [null]);
  }

  return /*#__PURE__*/_react.default.createElement(_Checkable.StyledCheckable, {
    className: className,
    "data-test-id": dataTestId
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    checked: checked,
    className: "c-checkable-input",
    "data-test-id": "checkable-input",
    id: id || name,
    name: name,
    onChange: onChange,
    type: "checkbox"
  }, props)), formattedChildren[0] ? formattedChildren[0] : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: ['c-checkable-icon-wrapper', 'c-checkable-unchecked'].join(' '),
    colorTheme: uncheckedColorTheme || checkedColorTheme || colorTheme,
    dataTestId: "checkable-unchecked-icon",
    iconName: uncheckedIconName
  }), formattedChildren[1] ? formattedChildren[1] : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: ['c-checkable-icon-wrapper', 'c-checkable-checked'].join(' '),
    colorTheme: colorTheme || checkedColorTheme,
    dataTestId: "checkable-checked-icon",
    iconName: checkedIconName
  }));
};

Checkable.propTypes = {
  /** Where the checkbox is checked */
  checked: _propTypes.default.bool,

  /** checked color theme
   undefined,
   'default',
   'primary',
   'cta',
   'overDark',
   */
  checkedColorTheme: _propTypes.default.oneOf(_text.textThemes),

  /** Icon for Checked State */
  checkedIconName: _propTypes.default.string,

  /** Children should be an Icon, but Children can be any valid node or array of valid nodes */
  children: _propTypes2.default.children,

  /** classname hook */
  className: _propTypes.default.string,

  /** if your use of checkable only requires one color theme, use this guy */
  colorTheme: _propTypes.default.oneOf(_text.textThemes),

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** id */
  id: _propTypes.default.string,

  /** Checkbox name */
  name: _propTypes.default.string,

  /** onChange Hanlder */
  onChange: _propTypes.default.func,

  /** unchecked color theme - will default to the same theme as the 'checked' color theme if not provided
   undefined,
   'default',
   'primary',
   'cta',
   'overDark',
   */
  uncheckedColorTheme: _propTypes.default.oneOf(_text.textThemes),

  /** Icon for Unchecked State */
  uncheckedIconName: _propTypes.default.string
};
Checkable.defaultProps = {
  checked: false,
  checkedColorTheme: undefined,
  checkedIconName: 'check-square',
  children: [null, null],
  className: undefined,
  colorTheme: 'primary',
  id: (0, _idGenerator.default)(),
  name: undefined,
  onChange: function onChange() {},
  uncheckedColorTheme: undefined,
  uncheckedIconName: 'square'
};
var _default = Checkable;
exports.default = _default;